import { iPermissionFields, PermissionLevelEnum, PermissionSection } from "@models/PermissionSection";
import { components } from "@apiSchema";
import { ID } from "@models/index";
import { randomizeInRange } from "@core/old_helpers";


const CONSUMER_TYPES_IDS_ORDERED: ID[] = [
    1,  // Total US
    3,  // Female
    2,  // Male
    4,  // Gen Z
    5,  // Millennials
    6,  // Gen X
    7,  // Boomers
    8,  // White
    9,  // Black
    10, // Hispanic
    11, // Asian
    12, // West
    13, // Midwest
    15, // South
    14, // North East
];

const CONSUMER_HEAT_SCORE_LEVELS: ID[] = [
    5, // declining
    4, // flat
    3, // gaining slow
    2, // gaining fast
    1, // on fire
];

export interface IFoodProfileConsumerData {
    keywordName: string;
    link: string;
    loveLikeIt: number;
    knowIt: number;
    haveTriedIt: number;
    dataByDemoGroups: Array<{
        groupName: string;
        items: Array<{
            id: ID;
            name: string;
            loveLikeItRaw: number;
            knowItRaw: number;
            loveLikeItNorm: number;
            knowItNorm: number;
        }>;
    }>;
    heatScore: {
        knowIt: number;
        loveIt: number;
        triedIt: number;
        heatLevelId: number;
        tooltipText: string;
        config: Array<{
            id: number;
            name: string;
            description: string;
        }>;
    }
}

export interface IFoodProfileConsumer extends iPermissionFields {
    data: IFoodProfileConsumerData;
}

type ApiModel = components["schemas"]["FoodProfileMenuTrendsAndFlavorDataViewModel"];

interface IData {
    apiModel?: ApiModel;
}

export class FoodProfileConsumer implements IFoodProfileConsumer {
    static readonly defaultData: IFoodProfileConsumerData = {
        keywordName: '',
        link: '',
        loveLikeIt: 0,
        knowIt: 0,
        haveTriedIt: 0,
        dataByDemoGroups: [],
        heatScore: {
            knowIt: 0,
            loveIt: 0,
            triedIt: 0,
            heatLevelId: 0,
            tooltipText: '',
            config: [],
        },
    };

    static readonly fakeData: IFoodProfileConsumerData = {
        keywordName: 'Fake Data',
        link: '',
        loveLikeIt: 90,
        knowIt: 50,
        haveTriedIt: 50,
        dataByDemoGroups: [
            {
                groupName: '',
                items: [
                    {
                        id: 1,
                        name: 'Item 1',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                ],
            },
            {
                groupName: 'Group 1',
                items: [
                    {
                        id: 1,
                        name: 'Item 1',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 2,
                        name: 'Item 2',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                ],
            },
            {
                groupName: 'Group 2',
                items: [
                    {
                        id: 1,
                        name: 'Item 1',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 2,
                        name: 'Item 2',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 3,
                        name: 'Item 3',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 4,
                        name: 'Item 4',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                ],
            },
            {
                groupName: 'Group 3',
                items: [
                    {
                        id: 1,
                        name: 'Item 1',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 2,
                        name: 'Item 2',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 3,
                        name: 'Item 3',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 4,
                        name: 'Item 4',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                ],
            },
            {
                groupName: 'Group 4',
                items: [
                    {
                        id: 1,
                        name: 'Item 1',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 2,
                        name: 'Item 2',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 3,
                        name: 'Item 3',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                    {
                        id: 4,
                        name: 'Item 4',
                        loveLikeItRaw: 50,
                        knowItRaw: 50,
                        loveLikeItNorm: 50,
                        knowItNorm: 50,
                    },
                ],
            },
        ],
        heatScore: {
            knowIt: 50,
            loveIt: 50,
            triedIt: 50,
            heatLevelId: 1,
            tooltipText: 'Fake Tooltip',
            config: [
                {
                    id: 1,
                    name: 'Fake Item',
                    description: 'Fake Description',
                },
                {
                    id: 2,
                    name: 'Fake Item',
                    description: 'Fake Description',
                },
                {
                    id: 3,
                    name: 'Fake Item',
                    description: 'Fake Description',
                },
                {
                    id: 4,
                    name: 'Fake Item',
                    description: 'Fake Description',
                },
                {
                    id: 5,
                    name: 'Fake Item',
                    description: 'Fake Description',
                },
            ],
        },
    };

    data = { ...FoodProfileConsumer.defaultData };
    permissionLevel = PermissionLevelEnum.Full;
    hasData = true;

    constructor(data?: IData) {
        if (data?.apiModel) {
            this.mapFromApiModel(data.apiModel);
        }
    }

    private setData(model: Partial<IFoodProfileConsumer>) {
        Object.assign(this, model);
    }

    private mapFromApiModel(apiModel: ApiModel) {
        const consumerPreferencesData = apiModel.consumerPreferencesData;
        const data = consumerPreferencesData?.consumerPreferencesWordData;
        const foodProfileWord = apiModel.foodProfileWord;

        const {
            keywordUrl,
            loveLikeIt,
            knowIt,
            haveTriedIt,
        } = data?.data ?? {};

        const permissionLevel = PermissionSection.getPermissionLevel(data?.permissionLevel);

        this.setData({
            permissionLevel,
            hasData: data?.hasData ?? false,
            data: permissionLevel === PermissionLevelEnum.None
                ? ({
                    ...FoodProfileConsumer.fakeData,
                    keywordName: foodProfileWord ?? FoodProfileConsumer.defaultData.keywordName,
                    dataByDemoGroups: FoodProfileConsumer.getConsumerDemoGroups(consumerPreferencesData)
                        .map(group => ({
                            ...group,
                            items: group.items.map(item => ({
                                ...item,
                                loveLikeItRaw: randomizeInRange(0, 100),
                                knowItRaw: randomizeInRange(0, 100),
                                loveLikeItNorm: randomizeInRange(0, 100),
                                knowItNorm: randomizeInRange(0, 100),
                            })),
                        })),
                })
                : ({
                    keywordName: foodProfileWord ?? FoodProfileConsumer.defaultData.keywordName,
                    link: keywordUrl ?? FoodProfileConsumer.defaultData.link,
                    loveLikeIt: loveLikeIt?.generalData?.raw ?? FoodProfileConsumer.defaultData.loveLikeIt,
                    knowIt: knowIt?.generalData?.raw ?? FoodProfileConsumer.defaultData.knowIt,
                    haveTriedIt: haveTriedIt?.generalData?.raw ?? FoodProfileConsumer.defaultData.haveTriedIt,
                    dataByDemoGroups: FoodProfileConsumer.getConsumerDemoGroups(consumerPreferencesData),
                    heatScore: FoodProfileConsumer.getHeatScoreData(consumerPreferencesData),
                }),
        });
    }

    static getRespondentTypeData(typeId: ID, data?: components["schemas"]["FlavorDataByRespondentType"][]) {
        return data?.find(i => i.respondentTypeId === typeId)?.data;
    }

    static getHeatScoreData(apiModel: ApiModel['consumerPreferencesData']) {
        const config = apiModel?.config;
        const data = apiModel?.consumerPreferencesWordData;

        const {
            heatLevelInfo = [],
            heatScoresTooltip = '',
        } = config ?? {};

        const {
            knowIt = 0,
            loveIt = 0,
            triedIt = 0,
            heatLevel = 0,
        } = data?.data?.heatScore ?? {};

        const configData = (heatLevelInfo ?? []).map(level => ({
            id: level.id ?? 0,
            name: level.name ?? '',
            description: level.description ?? '',
        }));

        configData.sort((a, b) => {
            return CONSUMER_HEAT_SCORE_LEVELS.indexOf(a.id) - CONSUMER_HEAT_SCORE_LEVELS.indexOf(b.id);
        });

        return {
            knowIt: knowIt ?? 0,
            loveIt: loveIt ?? 0,
            triedIt: triedIt ?? 0,
            heatLevelId: heatLevel ?? 0,
            tooltipText: heatScoresTooltip ?? '',
            config: configData,
        };
    }

    static getConsumerDemoGroups(apiModel: ApiModel['consumerPreferencesData']): IFoodProfileConsumerData['dataByDemoGroups'] {
        const config = apiModel?.config;
        const data = apiModel?.consumerPreferencesWordData;

        const {
            loveLikeIt,
            knowIt,
        } = data?.data ?? {};

        const {
            respondentGroupTypeInfo = []
        } = config ?? {};

        const filteredGroupTypes = (respondentGroupTypeInfo ?? [])
            .map(group => ({
                groupName: group.groupName ?? '',
                types: (group.types ?? []).filter(item => item.id && CONSUMER_TYPES_IDS_ORDERED.includes(item.id)),
            }))
            .filter(group => group.types.length > 0);

        const result = filteredGroupTypes.map(group => ({
            groupName: group.groupName,
            items: group.types.map(item => ({
                id: item.id ?? 0,
                name: item.name ?? '',
                loveLikeItRaw: FoodProfileConsumer.getRespondentTypeData(item.id ?? 0, loveLikeIt?.dataByRespondentType ?? undefined)?.raw ?? FoodProfileConsumer.defaultData.loveLikeIt,
                knowItRaw: FoodProfileConsumer.getRespondentTypeData(item.id ?? 0, knowIt?.dataByRespondentType ?? undefined)?.raw ?? FoodProfileConsumer.defaultData.knowIt,
                loveLikeItNorm: FoodProfileConsumer.getRespondentTypeData(item.id ?? 0, loveLikeIt?.dataByRespondentType ?? undefined)?.norm ?? FoodProfileConsumer.defaultData.loveLikeIt,
                knowItNorm: FoodProfileConsumer.getRespondentTypeData(item.id ?? 0, knowIt?.dataByRespondentType ?? undefined)?.norm ?? FoodProfileConsumer.defaultData.knowIt,
            })),
        }));

        result.forEach(({ items }) => {
            items.sort((item1, item2) => {
                return CONSUMER_TYPES_IDS_ORDERED.indexOf(item1.id) - CONSUMER_TYPES_IDS_ORDERED.indexOf(item2.id);
            });
        });

        result.sort((group1, group2) => {
            return CONSUMER_TYPES_IDS_ORDERED.indexOf(group1.items[0].id) - CONSUMER_TYPES_IDS_ORDERED.indexOf(group2.items[0].id);
        });

        return result;
    }
}